import { UserMeta, connectionIdToColor, useOthers, useSelf } from './liveblocks-notes.config'

import { getUserInitials } from '@/lib/string/string-utils'

import { Avatar, AvatarFallback, AvatarImage } from '@/components/lemmala-design-system/avatar'
import { Tooltip } from '@/components/lemmala-design-system/tooltip/tooltip'

export const LiveblocksAvatars = () => {
  const users = useOthers()

  const currentUser = useSelf()

  return (
    <div className='flex [&>*]:-mr-3'>
      {users.map(({ connectionId, info }) => {
        return <LiveblocksAvatar key={connectionId} connectionId={connectionId} info={info} />
      })}

      {currentUser && (
        <LiveblocksAvatar connectionId={currentUser.connectionId} info={currentUser.info} />
      )}
    </div>
  )
}

export const LiveblocksAvatar = ({
  connectionId,
  info,
}: {
  connectionId: number
  info: UserMeta['info']
}) => {
  const color = connectionIdToColor(connectionId)
  const userInitials = getUserInitials(info.name ?? '')

  const avatarClassName = '-mt-2 border-2 bg-main-background-muted drop-shadow-md'
  return (
    <Tooltip
      trigger={
        <Avatar
          size='medium'
          className={avatarClassName}
          style={{ borderColor: color }}
          aria-label={info.name}
        >
          <AvatarImage src={info.avatar} alt={info.name} title={info.name} />
          <AvatarFallback size='medium'>{userInitials}</AvatarFallback>
        </Avatar>
      }
    >
      {info.name}
    </Tooltip>
  )
}
